import * as React from 'react';
import type { NavItem } from 'baseui/app-nav-bar';
import { AppNavBar, setItemActive } from 'baseui/app-nav-bar';
export default function Header(props) {
  const {
    mainItems,
    setMainItems
  } = props;
  function handleMainItemSelect(item: NavItem) {
    setMainItems(prev => setItemActive(prev, item));
  }
  return <AppNavBar title="uLabel Lite Admin" mainItems={mainItems} onMainItemSelect={handleMainItemSelect} />;
}